export const environment = {
  name: 'staging',
  production: false,
  api_url: 'https://api-staging.littleworker.fr/2.0',
  auth_url: 'https://moncompte-staging.littleworker.fr',
  customer_url: 'https://staging-monespace.littleworker.fr'
};
